export type Hold = {
  id: string;
  title: string;
  recordId: string;
  issueDate: string;
  recordhunkId: string;
  rssRhId: string;
  holdQueuePosition: number;
  startTime: Date;
  endTime: Date;
  notifiedTime: Date;
  availableUntilTime: Date;
  holdDate: Date;
  status: HoldStatus;
  parentRecordId: string;
  format: string;
};

export type AcceptHoldResponse = {
  status: AcceptStatus;
  recordId?: string;
  issueDate?: string;
};

export type WaitingTime = {
  waitingTime: number;
};

export enum EnumHoldStatus {
  informed = 'informed',
  downloaded = 'downloaded',
  waiting = 'waiting',
  cancelled = 'cancelled',
  expired = 'expired',
}

export type HoldStatus = 'waiting' | 'informed' | 'expired' | 'downloaded' | 'cancelled';
export type AcceptStatus =
  | 'ACCEPTED'
  | 'HOLD_DOES_NOT_EXIST'
  | 'MORE_THAN_ONE_HOLD'
  | 'EXPIRED_HOLD'
  | 'DOES_NOT_BELONG_TO_USER'
  | 'UNKNOWN_USER'
  | 'BAD_REQUEST';
